import React, {Component} from 'react'
import PropTypes from 'prop-types'

class BasketPosition extends Component {
    _handleChange = e => {
        const {position, onChangeFilterPosition} = this.props
        onChangeFilterPosition('position', position.toString())
    }

    render() {
        const {position} = this.props

        return (
            <td className='BasketPosition'>
                {
                    position && 
                    <span className="cursor-pointer" onClick={this._handleChange}>
                        {position}
                    </span>
                }
            </td>
        )
    }
}

BasketPosition.propTypes = {
    position: PropTypes.string.isRequired,
}

export default BasketPosition
